module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_4.88c58a27.png";